module.exports = __webpack_public_path__ + "static/img/introDownload.c3997fbd.png";